import { useEffect, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'
import {  useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import avatarPlaceholder from 'assets/images/user_placeholder.png'
import GuestSubscribeLogin from 'components/UI/Modal/profileModals/GuestSubscribeLogin/GuestSubscribeLogin'
// import VerifyNav from 'components/UI/VerifyNav/VerifyNav'
import { NewPostPopup } from 'components-ref/molecules'
import { useModalContext } from 'context/modalContext'
import { usePreviewContext } from 'context/previewContext'
import { AllIcons } from 'helpers/allIcons'
import { Menu } from 'pages/newmenu/index'
import { useAccessToken, useUserProfile } from 'store'
import { usePendingNotificationsStore } from 'store/pendingNotificationsStore'
import { useProfileCacheStore } from 'store/profileCacheStore'
import colors from 'styles/colors'
import screens from 'styles/screens'

import './_footer.scss'

const Footer = () => {
  const [postPopupActive, setPostPopupActive] = useState(false)

  const userData = useUserProfile()
  const location = useLocation()

  const modalData = useModalContext()
  const previewContext = usePreviewContext()

  const { t } = useTranslation()

  const notificationsCount = usePendingNotificationsStore(s => s.notifications)
  const messagesCount = usePendingNotificationsStore(s => s.messages)
  const setNotifications = usePendingNotificationsStore(
    s => s.resetNotifications
  )

  const refButton = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  const isAuthenticated = useAccessToken() !== ''

  const profileUsername = location.pathname.split('/')[1] || ''
  const profile = useProfileCacheStore(s => s.getProfile(profileUsername))

  const closePreviewModal = () => {
    previewContext?.clearModal?.()
    previewContext?.resetPreviewState?.()
  }

const openSubscribeModal = () => {
  closePreviewModal()

  modalData.addModal(
    'subscribe-profile',
    <GuestSubscribeLogin
      username={profile?.username ?? ''}
      cover={profile?.cover?.url ?? null}
      displayName={profile?.display_name ?? ''}
      avatar={profile?.avatar?.url ?? avatarPlaceholder}
      onClose={() => modalData.clearModal()}
      hideProfileHeader={true}
    />,
    true,
    true,
    'modal--subscribe-profile-modal',
    'subscribe-profile'
  )
}

const handleNavClick = (path: string, allowGuest = false) => {
  closePreviewModal()

  if (!isAuthenticated && !allowGuest) return openSubscribeModal()

  setPostPopupActive(false)
  modalData.clearModal()

  if (location.pathname === path) {
    return
  }

  navigate(path)
}

  const handleMenuClick = () => {
    if (!isAuthenticated) return openSubscribeModal()

    setPostPopupActive(false)

    if (modalData.isOpen && modalData.key === 'menu') {
      modalData.clearModal()
      return
    }

    modalData.clearModal()
    modalData.addModal(
      'menu',
      <Menu />,
      false,
      false,
      'modal--menuFullscreen',
      'menu'
    )
  }

  const handleAddPostClick = () => {
    closePreviewModal()

    if (!isAuthenticated) return openSubscribeModal()

    modalData.clearModal()
    setPostPopupActive(prev => !prev)
  }

const openDiscoverPreview = () => {
  if (!isAuthenticated) return openSubscribeModal()

  document.body.style.background = '#000'
  navigate('/discover/reels')
}
  const isNotificationsPage = [
    '/notifications',
    '/notifications/fans',
    '/notifications/site'
  ].includes(location.pathname)

  useEffect(() => {
    if (isNotificationsPage && notificationsCount > 0) {
      setNotifications()
    }
  }, [isNotificationsPage, notificationsCount, setNotifications])

  return (
    <FooterWrapper>
      <FooterContainer $menuOpen={modalData.isOpen && modalData.key === 'menu'}>
      {userData?.role === 'model' && (
        <NewPostPopup
          isOpen={postPopupActive}
          setIsOpen={setPostPopupActive}
          refButton={refButton}
        />
      )}

        <div
          className="footer__link"
          onClick={() =>
            handleNavClick(
              !isAuthenticated
                ? '/'
                : userData?.role === 'model'
                  ? `/${userData?.username}`
                  : '/following',
              true
            )
          }
        >
          <img
            src={
              (userData?.role === 'model' &&
                location.pathname === `/${userData?.username}`) ||
              (userData?.role !== 'model' &&
                location.pathname === '/following')
                ? AllIcons.footer_home_active
                : AllIcons.footer_home
            }
            alt={t('home')}
          />
        </div>

        {userData?.role === 'model' ? (
          <div
            className="footer__link"
            onClick={() => handleNavClick('/notifications')}
          >
            {notificationsCount > 0 && (
              <div className="footer__link__status">
                {notificationsCount}
              </div>
            )}

            <img
              src={
                isNotificationsPage
                  ? AllIcons.footer_notifications_active
                  : AllIcons.footer_notifications
              }
              alt={t('notifications')}
            />
          </div>
        ) : (
<div
  className="footer__link"
  onClick={() => handleNavClick('/media')}
>
  <img
    className="footer__favorites-icon"
    src={
      location.pathname === '/media'
        ? AllIcons.footer_favorites_active
        : AllIcons.footer_favorites
    }
    alt={t('media')}
  />
</div>
        )}

        {userData?.role === 'model' ? (
          <div
            className={`footer__link footer__link--addpost${
              postPopupActive ? ' footer__link--addpost--active' : ''
            }`}
            ref={refButton}
            onClick={handleAddPostClick}
          >
            <img src={AllIcons.footer_addpost} alt="Add post" />
          </div>
        ) : (
          <div className="footer__link"  onClick={() => handleNavClick('/discover/reels')}/* onClick={openDiscoverPreview} */>
            <img src={AllIcons.footer_media} alt={t('discover')} />
          </div>
        )}

        <div className="footer__link" onClick={() => handleNavClick('/chat')}>
          {messagesCount > 0 && (
            <div className="footer__link__status">{messagesCount}</div>
          )}

          <img
            src={
              location.pathname.includes('/chat')
                ? AllIcons.footer_chat_active
                : AllIcons.footer_chat
            }
            alt={t('chat')}
          />
        </div>

        <div className="profile__menu" onClick={handleMenuClick}>
          <img
            className="footer__link--avatar"
            src={userData?.avatar?.url ?? avatarPlaceholder}
            alt={t('profile')}
            onError={e => {
              e.currentTarget.onerror = null
              e.currentTarget.src = avatarPlaceholder
            }}
          />
        </div>
      </FooterContainer>

      {/* <VerifyNav /> */}
    </FooterWrapper>
  )
}

export default Footer
const FooterContainer = styled.footer<{ $menuOpen: boolean }>`
  background: ${colors.black157deg};
  height: 6.5rem;
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: content-box;

  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;

  width: 100%;
  border-radius: 3.5rem 3.5rem 0 0;
  z-index: ${({ $menuOpen }) => ($menuOpen ? 10002 : 10)};

  display: flex;
  justify-content: space-around;
  align-items: center;
`
/* const FooterContainer = styled.footer`
  background: ${colors.black157deg};
  height: 7rem;
  position: fixed;
  bottom: -0.1rem;
  width: 100%;
  border-radius: 3.5rem 3.5rem 0 0;
  z-index: 10;
  display: flex;
  justify-content: space-around;
  align-items: center;
` */

const FooterWrapper = styled.div`
  @media (min-width: ${screens.medium}) {
    display: none;
  }
`